// Lightweight site animations — no frameworks
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // 1) Scroll reveal
  const revealTargets = [
    ...document.querySelectorAll('.reveal'),
    // Auto-reveal top-level sections (nice default)
    ...document.querySelectorAll('main .shopify-section')
  ];

  const seen = new WeakSet();
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !seen.has(entry.target)) {
        entry.target.classList.add('reveal', 'is-inview');
        seen.add(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  revealTargets.forEach(el => io.observe(el));

  // 2) Button ripple
  const rippleSelector = 'a.button, .button, .btn, button, [type="submit"], .shopify-payment-button__button';
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(rippleSelector);
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    const x = (e.clientX || (rect.left + rect.width / 2)) - rect.left;
    const y = (e.clientY || (rect.top + rect.height / 2)) - rect.top;
    const span = document.createElement('span');
    span.className = 'ripple';
    span.style.left = x + 'px';
    span.style.top = y + 'px';
    btn.appendChild(span);
    setTimeout(() => span.remove(), 650);
  }, { passive: true });

  // 3) Cart badge pop when adding to cart
  function popCartBadge() {
    const candidates = [
      document.querySelector('.jr-icon--cart .jr-badge'),
      document.querySelector('header [data-cart-count]'),
      document.querySelector('header .cart-count'),
      document.querySelector('header .header__cart-count')
    ].filter(Boolean);
    const badge = candidates[0];
    if (!badge) return;
    badge.classList.remove('cart-bounce'); // restart animation
    // force reflow
    void badge.offsetWidth;
    badge.classList.add('cart-bounce');
  }

  // Hook common add-to-cart flows
  // a) Intercept product forms
  document.querySelectorAll('form[action*="/cart/add"]').forEach(f => {
    f.addEventListener('submit', () => setTimeout(popCartBadge, 450));
  });
  // b) Listen for Shopify events some themes dispatch
  ['cart:updated', 'cart:add', 'cart:change'].forEach(ev => {
    document.addEventListener(ev, () => popCartBadge(), { passive: true });
  });

})();